<template>
  <div class="message-wrap">
    <div class="message-search">
      <!-- 顶部搜索块 -->
      <el-form :inline="true" :model="formData" class="search-form" ref="searchFormRef" size="small">
        <el-row :gutter="22">
          <el-col class="search-col">
            <el-form-item :label="$t('mess.mess82')" prop="remindingTitle">
              <el-input v-model="formData.remindingTitle" :placeholder="$t('createOrder.createOrder84')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('logistics.logistics14')">
              <el-date-picker
                clearable
                class="max-picker"
                v-model="dataTime"
                type="daterange"
                :start-placeholder="$t('datePicker.start')"
                :end-placeholder="$t('datePicker.end')"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('mess.mess63')" prop="orderOrContainerId" style="min-width: 20%">
              <el-input v-model="formData.orderOrContainerId" :placeholder="$t('createOrder.createOrder84')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('mess.mess54')" prop="customerFavorites">
              <el-select v-model="formData.customerFavorites" :placeholder="$t('createOrder.createOrder84')" clearable>
                <el-option v-for="item in collectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$t('mess.mess47')">
              <el-input v-model="formData.createUserName" :placeholder="$t('mess.mess62')" clearable></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('recycle.recycle2')">
              <el-select v-model="formData.isRead" placeholder="请选择状态" clearable>
                <el-option :label="$t('recycle.recycle5')" value=""></el-option>
                <el-option :label="$t('recycle.recycle4')" value="1"></el-option>
                <el-option :label="$t('recycle.recycle3')" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-col>
            <div class="search-button-wrap">
              <el-checkbox-group v-model="formData.type" size="small" @change="handleCheckBoxChange">
                <el-checkbox-button v-for="item in messageType" :label="item.type" :key="item.type">{{item.name}}</el-checkbox-button>
              </el-checkbox-group>
              <el-form-item class="form-btn1">
                <el-button class="search-btn btn-gray" @click="handleReset">{{ $t("mess.mess11") }}</el-button>
                <el-button class="search-btn btn-blue" @click="handleSearch">{{ $t("mess.mess12") }}</el-button>
                <el-button class="search-btn btn-green" @click="showMessageDialog">{{ $t("mess.mess76") }}</el-button>
                <el-button class="search-btn btn-red" @click="goRecycle">{{ $t("recycle.recycle1") }}</el-button>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="message-content" v-loading="messageListLoading">
      <div class="message-left-wrap">
        <div
          class="message-content-left"
          :class="{ 'flex-div': leftIsEmpty }"
          v-infinite-scroll="load"
          :infinite-scroll-disabled="disabled"
          :infinite-scroll-immediate="false"
        >
          <!-- 左侧收发列表 -->
          <div v-if="!leftIsEmpty" class="message-list">
            <div
              v-for="item in messageList"
              :key="item.id"
              class="message-list-item"
              :class="{ 'active-item': activeId && item.messageGroupId === activeId, 'active-sys-item': sysMsgId && sysMsgId === item.id }"
              @click="handleMessageItem(item)"
            >
              <!--<el-badge :is-dot="item.unreadCount ? true : false" />-->
              <el-badge :is-dot="item.readLevel == '2' ? true : false" />
              <div class="text-overflow text-cursor">
                <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'createUserName'), padding: '0 5px' }">{{
                  prefix(item, "createUserName")
                }}</span>
                <span style="margin-left: 5px;" :style="{ color: prefixColor(item, 'createUserName') }">{{
                  prefix(item, "createUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : item.createUserName
                }}</span>
                {{ `${$t("mess.mess20")} ${dataTimeFn(item.createTime)}` }}
                <!-- <span v-if="item.orderId" style="margin-left: 25px">{{ `[${$t("mess.mess19")}: ${item.orderId}]` }}</span> -->
              </div>
              <div class="message-info">
                <span class="label">{{ `${$t("mess.mess21")}：` }}</span>
                <span class="text-content text-overflow">{{ item.remindingTitle }}</span>
              </div>
              <div class="message-info">
                <span class="label">{{ `${$t("mess.mess22")}：` }}</span>
                <span class="html-content text-overflow">
                  <div v-html="item.remindingContent" class="text-overflow"></div>
                </span>
              </div>
              <i v-if="item.customerFavorites == '1' && item.createUserName !== 'system'" class="el-icon-star-on collect-icon"></i>
            </div>
          </div>
          <!-- <el-empty v-else :description="$t('mess.mess66')"></el-empty> -->
          <span v-else class="empty-text">{{ $t("mess.mess66") }}</span>
        </div>
        <div class="pagination-footer">
          <el-pagination
            small
            @current-change="handleCurrentChange"
            :current-page="formData.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="formData.pageSize"
            layout="total, prev, pager, next"
            :total="messageTotal"
          ></el-pagination>
          <el-button size="mini" class="search-btn btn-blue" @click="handleReadAll">{{ $t("mess.mess13") }}</el-button>
        </div>
      </div>

      <div v-if="activeId && messageDetailList.length" class="message-content-right">
        <!-- 回复 -->
        <div class="send-message-wrap" :class="{ reply: showReply }">
          <message-form
            ref="messageFormRef"
            :message-group="messageDetailList"
            :info="activeItem"
            submit-url="cmUser/message2/reply"
            @refreshData="refreshData"
          />
        </div>
        <!-- 过往收发详情列表 -->
        <div v-for="(item, index) in messageDetailList" class="message-list-item" :class="{ 'history-message-item': index !== 0 }" :key="index">
          <h3 :class="{ 'first-title': index === 0 && item.createUserName !== 'system' && activeItem.isReply == 1 }">{{ item.remindingTitle }}</h3>
          <div class="send-info">
            <span>
              {{ `${$t("mess.mess47")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'createUserName'), padding: '0 5px' }">{{
                prefix(item, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'createUserName') }">
                {{prefix(item, "createUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : item.createUserName}}
                <el-popover
                  v-if="prefix(item, 'createUserName') === $t('recycle.recycle11') && item.createUserId"
                  placement="top"
                  trigger="click"
                  width="440"
                  @show="handleResumePopoverShow(item.createUserId)"
                >
                  <div class="resume-popover" v-loading="resumeLoadingMap[item.createUserId]">
                    <div v-if="getResumeInfoEntries(resumeInfoMap[item.createUserId]).length" class="resume-info-list">
                      <div
                        v-for="(entry, entryIndex) in getResumeInfoEntries(resumeInfoMap[item.createUserId])"
                        :key="`${item.createUserId}-${entry.key}-${entryIndex}`"
                        class="resume-info-row"
                        :class="{ 'resume-info-photo-row': entry.type === 'image', 'resume-info-intro-row': entry.key === 'introduction' }"
                      >
                        <span class="resume-info-label">{{ entry.label }}:</span>
                        <div class="resume-info-value">
                          <img
                            v-if="entry.type === 'image'"
                            :src="entry.value"
                            alt=""
                            class="resume-photo"
                            @click.stop="imgclick(entry.value)"
                          />
                          <span v-else>{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                    <span v-else>{{ $t("mess.mess68") }}</span>
                  </div>
                  <span slot="reference" class="resume-tip" @click.stop>?</span>
                </el-popover>
              </span>
              </span>
            <span>
              {{ `${$t("mess.mess67")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'remindingUserName'), padding: '0 5px' }">{{
                prefix(item, "remindingUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'remindingUserName') }">
                {{prefix(item, "remindingUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : item.remindingUserName}}
                <el-popover
                  v-if="prefix(item, 'remindingUserName') === $t('recycle.recycle11') && item.remindingUserId"
                  placement="top"
                  trigger="click"
                  width="440"
                  @show="handleResumePopoverShow(item.remindingUserId)"
                >
                  <div class="resume-popover" v-loading="resumeLoadingMap[item.remindingUserId]">
                    <div v-if="getResumeInfoEntries(resumeInfoMap[item.remindingUserId]).length" class="resume-info-list">
                      <div
                        v-for="(entry, entryIndex) in getResumeInfoEntries(resumeInfoMap[item.remindingUserId])"
                        :key="`${item.remindingUserId}-${entry.key}-${entryIndex}`"
                        class="resume-info-row"
                        :class="{ 'resume-info-photo-row': entry.type === 'image', 'resume-info-intro-row': entry.key === 'introduction' }"
                      >
                        <span class="resume-info-label">{{ entry.label }}:</span>
                        <div class="resume-info-value">
                          <img
                            v-if="entry.type === 'image'"
                            :src="entry.value"
                            alt=""
                            class="resume-photo"
                            @click.stop="imgclick(entry.value)"
                          />
                          <span v-else>{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                    <span v-else>{{ $t("mess.mess68") }}</span>
                  </div>
                  <span slot="reference" class="resume-tip" @click.stop>?</span>
                </el-popover>
              </span>
            </span>
            <span>{{ `${$t("mess.mess20")}：${dataTimeFn(item.createTime)}` }}</span>
          </div>
          <div class="rich-text-content">
            <div v-html="item.remindingContent"></div>
          </div>
          <el-form label-width="130px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="8">
                <el-form-item :label="`${$t('mess.mess19')}：`">
                  <span class="under-text primary-text" @click="toOrderDetail(item)">
                    {{ item.orderId || $t("mess.mess68") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item :label="`${$t('mess.mess69')}：`">
                  <span class="under-text primary-text" @click="toFBA">{{ item.containerBatchNo || $t("mess.mess68") }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item :label="`${$t('mess.mess45')}：`">
              <div v-if="item.fileModels && item.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="(annex,newIndex) in item.fileModels" :key="newIndex">
                  <img v-if="isImage(annex.filePath)" @click="imgclick(annex.filePath, true)" :src="annex.filePath" alt="">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <!--<span class="under-text primary-text" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    $t("orderList.orderList147")
                  }}</span>-->
                </div>
              </div>
              <span v-else class="under-text primary-text">{{ $t("mess.mess68") }}</span>
            </el-form-item>
          </el-form>
          <div class="history-text" v-if="messageDetailList.length > 1 && index === 0">{{ $t("mess.mess70") }}</div>
        </div>
        <!-- 右上角操作按钮：回复、收藏、发送、取消 -->
        <div class="send-list-operate">
          <el-button v-if="activeItem.readLevel == '2'" size="small" class="search-btn btn-blue" @click="handleRead('')">{{$t('mess.mess10')}}</el-button>
          <el-button size="small" class="search-btn btn-red" @click="handleDelete(activeItem)">{{ $t("delete") }}</el-button>
          <div v-if="!showReply">
            <!-- <el-button size="small" class="search-btn btn-gray" @click="handleRead('')">已读</el-button> -->
            <el-button size="small" class="search-btn" :class="activeItem.customerFavorites == 1 ? 'btn-gray' : 'btn-blue'" @click="handleCollect">{{
              activeItem.customerFavorites == 1 ? $t("mess.mess71") : $t("mess.mess54")
            }}</el-button>
            <el-button size="small" class="search-btn btn-blue" @click="handleReply">{{ $t("mess.mess79") }}</el-button>
          </div>
          <div v-else>
            <el-button size="small" class="search-btn btn-gray" @click="handleCancel">{{ $t("cancel") }}</el-button>
            <el-button size="small" class="search-btn btn-blue" @click="handleSend('messageFormRef')">{{ $t("loginR.login32") }}</el-button>
          </div>
        </div>
      </div>
      <div v-else-if="messageList.length && !activeId && sysMsgId" class="message-content-right">
        <div class="message-list-item" v-if="activeItem">
          <h3>{{ activeItem.remindingTitle }}</h3>
          <div class="send-info">
            <span>
              {{ `${$t("mess.mess47")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(activeItem, 'createUserName'), padding: '0 5px' }">{{
                prefix(activeItem, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(activeItem, 'createUserName') }">{{
                prefix(activeItem, "createUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : activeItem.createUserName
              }}</span>
            </span>
            <span>
              {{ `${$t("mess.mess67")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(activeItem, 'remindingUserName'), padding: '0 5px' }">{{
                prefix(activeItem, "remindingUserName")
              }}</span>
              <span :style="{ color: prefixColor(activeItem, 'remindingUserName') }">{{
                prefix(activeItem, "remindingUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : activeItem.remindingUserName
              }}</span>
            </span>
            <span>{{ `${$t("mess.mess20")}：${dataTimeFn(activeItem.createTime)}` }}</span>
          </div>
          <div class="rich-text-content">
            <div v-html="activeItem.remindingContent"></div>
          </div>
          <el-form label-width="130px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="8">
                <el-form-item :label="`${$t('mess.mess19')}：`">
                  <span class="under-text primary-text" @click="toOrderDetail(activeItem)">
                    {{ activeItem.orderId || $t("mess.mess68") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item :label="`${$t('mess.mess69')}：`">
                  <span class="under-text primary-text" @click="toFBA">{{ activeItem.containerBatchNo || $t("mess.mess68") }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <!-- <el-form-item :label="`${$t('mess.mess45')}：`">
              <div v-if="activeItem.fileModels && activeItem.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="annex in activeItem.fileModels">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <span class="under-text primary-text" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    $t("orderList.orderList147")
                  }}</span>
                </div>
              </div>
              <span v-else class="under-text primary-text">{{ $t("mess.mess68") }}</span>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="send-list-operate system-operate">
          <el-button v-if="newItem.readLevel == '2'" size="small" class="search-btn btn-blue" @click="handleRead('')">{{$t('mess.mess10')}}</el-button>
          <el-button size="small" class="search-btn btn-red" @click="handleDelete(activeItem)">{{ $t("delete") }}</el-button>
          <!-- <el-button size="small" class="search-btn btn-gray" @click="handleCollect">{{ activeItem.customerFavorites == 1 ? "已收藏" : "收藏" }}</el-button> -->
        </div>
      </div>
      <div v-else class="message-content-right flex-div">
        <!-- <el-empty :description="$t('mess.mess75')"></el-empty> -->
        <span v-if="leftIsEmpty" class="empty-text">{{ $t("mess.mess75") }}</span>
      </div>
    </div>
    <!-- 发消息弹窗 -->
    <el-dialog :title="$t('createOrder.createOrder101')" :visible.sync="messageDialogVisible" @close="handleCloseDialog">
      <message-form ref="messageDialogFormRef" submit-url="cmUser/message2/sandMessageNew" @refreshData="refreshDialogData" />
      <div slot="footer" class="dialog-footer">
        <el-button class="search-btn btn-gray" @click="handleCloseDialog">{{ $t("cancel") }}</el-button>
        <el-button class="search-btn btn-blue" @click="handleSend('messageDialogFormRef')">{{ $t("loginR.login32") }}</el-button>
      </div>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="70%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
    </el-dialog>
  </div>
</template>

<script>
import { dataTimeFn, getTime, prefix, prefixColor } from "@/assets/js/utils";
import MessageForm from "./components/messageForm.vue";

export default {
  name: "newMessage",
  components: {
    MessageForm,
  },
  data() {
    return {
      formData: {
        createUserName: "",
        remindingTitle: "",
        customerFavorites: "",
        orderOrContainerId: "",
        pageSize: 50,
        pageNum: 1,
        isRead: "",
        type: ['staffMessageForward', 'clientMessageForward', 'systemMessageForward']
      },
      dataTime: [],
      collectList: [
        {
          value: 1,
          label: this.$t("mess.mess54"),
        },
        {
          value: "",
          label: this.$t("mess.mess64"),
        },
      ],
      messageListLoading: false,
      messageIsEmpty: false,
      messageList: [],
      messageTotal: 0,
      activeId: "",
      activeItem: null,
      messageDetailList: [],
      showReply: false,
      messageDialogVisible: false,
      dataTimeFn,
      getTime,
      leftIsEmpty: false,
      sysMsgId: "",
      prefix,
      prefixColor,
      visible: false,
      imgurl: "",
      resumeInfoMap: {},
      resumeLoadingMap: {},
      newItem: {},
      messageType: [
        {
          name: this.$t('recycle.recycle11'),
          type: "staffMessageForward",
        },
        {
          name: this.$t('recycle.recycle10'),
          type: "clientMessageForward",
        },
        {
          name: this.$t('recycle.recycle12'),
          type: "systemMessageForward",
        },
      ]
    };
  },
  computed: {
    noMore() {
      return this.messageList.length >= this.messageTotal;
    },
    disabled() {
      return this.messageListLoading || this.noMore;
    },
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    this.getMessageList();
  },
  methods: {
    imgclick(url) {
      this.visible = true;
      this.imgurl = url;
    },
    isImage(filename) {
      var ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      return (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif');
    },
    getResumeInfoEntries(data) {
      if (!data || typeof data !== "object" || Array.isArray(data)) return [];
      const fieldList = [
        {
          key: "name",
          label: this.$t("mess.resumeName"),
          value: this.getResumeFieldValue(data, ["name", "realName", "userName", "nickname"]),
        },
        {
          key: "photo",
          label: this.$t("mess.resumePhoto"),
          value: this.getResumeFieldValue(data, ["photo", "photoUrl", "avatar", "avatarUrl", "headImg", "headImgUrl", "imgUrl", "imageUrl"]),
          type: "image",
        },
        {
          key: "birthday",
          label: this.$t("mess.resumeBirthday"),
          value: this.getResumeFieldValue(data, ["birthday", "birthDate", "birth", "dateOfBirth"]),
        },
        {
          key: "nativePlace",
          label: this.$t("mess.resumeNativePlace"),
          value: this.getResumeFieldValue(data, ["nativePlace", "birthplace", "placeOfOrigin", "hometown"]),
        },
        {
          key: "schoolMajor",
          label: this.$t("mess.resumeSchoolMajor"),
          value: this.buildSchoolMajorValue(data),
        },
        {
          key: "introduction",
          label: this.$t("mess.resumeIntroduction"),
          value: this.getResumeFieldValue(data, ["introduction", "selfIntroduction", "introduce", "profile", "summary"]),
        },
      ];
      return fieldList.filter((item) => item.value);
    },
    getResumeFieldValue(data, keys = []) {
      for (const key of keys) {
        const value = data[key];
        if (value === null || value === undefined || value === "") continue;
        if (typeof value === "object") continue;
        return value;
      }
      return "";
    },
    buildSchoolMajorValue(data) {
      const school = this.getResumeFieldValue(data, ["school", "graduateSchool", "graduatedSchool", "college", "university"]);
      const major = this.getResumeFieldValue(data, ["major", "specialty", "profession"]);
      if (school && major) return `${school} / ${major}`;
      return school || major || "";
    },
    handleResumePopoverShow(userId) {
      if (!userId) return;
      if (Object.prototype.hasOwnProperty.call(this.resumeInfoMap, userId)) return;
      if (this.resumeLoadingMap[userId]) return;
      this.$set(this.resumeLoadingMap, userId, true);
      this.$http.get("/emp/userResume/info", {
        params: {
          userId,
        },
      }).then(({ data: res }) => {
        if (res.code === 200) {
          this.$set(this.resumeInfoMap, userId, res.data || {});
        } else {
          this.$set(this.resumeInfoMap, userId, {});
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$set(this.resumeInfoMap, userId, {});
        this.$message.error(this.$t("prompt.failed"));
      }).finally(() => {
        this.$set(this.resumeLoadingMap, userId, false);
      });
    },
    // 单条已读
    handleRead() {
      this.$confirm(this.$t("recycle.recycle16"), {
        confirmButtonText: this.$t("recycle.recycle14"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("recycle.recycle15"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$http.get(`cmUser/message2/readByGroup`,{ params: { id: this.activeItem.id } });
        if (res.code === 200) {
          this.activeItem.readLevel = 0
          this.newItem.readLevel = 0
          this.getMessageList();
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {});
    },
    handleReadAll() {
      this.$confirm(this.$t("recycle.recycle13"), {
        confirmButtonText: this.$t("recycle.recycle14"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("recycle.recycle15"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$http.get("cmUser/message2/allRead");
        if (res.code === 200) {
          this.getMessageList();
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {});
    },
    goRecycle() {
      this.$router.push({ path: "recycle" });
    },
    handleDelete(item) {
      this.$confirm(this.$t("createOrder.confirmDelete"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$http.get(`cmUser/message2/recycle/${item.id}`);
        if (res.code === 200) {
          this.getMessageList();
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {

      });
    },
    handleCurrentChange(newPage) {
      this.formData.pageNum = newPage;
      this.getMessageList();
    },
    getMessageList(isLoad) {
      this.messageListLoading = true;
      const hasTime = this.dataTime && this.dataTime.length;
      const endTime = hasTime && this.getTime(this.dataTime[1]);
      const endTimeStr = endTime && endTime.replace("00:00:00", "23:59:59");
      //获取信息列表
      this.$http
        .get("/cmUser/message2/list", {
          params: {
            ...this.formData,
            createTimeStart: hasTime ? this.getTime(this.dataTime[0]) : "",
            createTimeEnd: hasTime ? endTimeStr : "",
            clientMessageForward: this.formData.type.includes("clientMessageForward") ? 0 : 1,
            staffMessageForward: this.formData.type.includes("staffMessageForward") ? 0 : 1,
            systemMessageForward: this.formData.type.includes("systemMessageForward") ? 0 : 1,
            type: undefined
          },
        })
        .then(({ data: res }) => {
          if (res.code === 200 && res.data && res.data.list) {
            if (!isLoad) {
              // 初始化判断左侧是否为空列表
              if (!res.data.list.length) {
                this.messageDetailList = [];
                this.messageList = [];
                this.messageTotal = res.data.total;
              } else {
                this.messageTotal = res.data.total;
                // this.activeItem = res.data.list[0] || null;
                // this.activeId = res.data.list[0].messageGroupId || "";
                // if (!res.data.list[0].messageGroupId) {
                //   this.sysMsgId = res.data.list[0].id;
                // }
                this.messageList = res.data.list.map((msg) => {
                  // if (msg.id === res.data.list[0].id) {
                  //   msg.unreadCount = 0;
                  // }
                  return msg;
                });
                this.getRightDetail();
              }
            } else {
              // this.messageList = [...this.messageList, ...res.data.list];
            }
          }
        })
        .finally(() => {
          if (!this.messageList.length) {
            this.leftIsEmpty = true;
          } else {
            this.leftIsEmpty = false;
          }
          this.messageListLoading = false;
        });
    },
    getRightDetail() {
      if (this.activeId) {
        this.$http
          .get("/cmUser/message2/groupList", {
            params: {
              messageGroupId: this.activeId,
              remindingUserName: this.activeItem.remindingUserName,
            },
          })
          .then(({ data: res }) => {
            if (res.code === 200) {
              this.messageDetailList = res.data || [];
            }
          })
          .catch(() => {
            this.$message.error("接口请求失败");
          });
      }
      if (this.sysMsgId) {
        this.$http.get(`cmUser/message/queryMessageInfo/${this.sysMsgId}`).then(({ data: res }) => {
          if (res.code === 200 && res.data) {
            this.activeItem = res.data.length ? res.data[0] : null;
          } else {
            this.activeItem = null;
          }
        });
      }
    },
    load() {
      // this.formData.pageNum += 1;
      // this.getMessageList(true);
    },
    handleSearch() {
      this.formData.pageNum = 1;
      this.activeId = ''
      // 搜索
      this.getMessageList();
    },
    // 发消息
    showMessageDialog() {
      this.messageDialogVisible = true;
    },
    handleMessageItem(item) {
      this.activeItem = item;
      this.newItem = item;
      // 处理是否已读
      /*this.messageList = this.messageList.map((msg) => {
        if (msg.id === item.id) {
          msg.unreadCount = 0;
        }
        return msg;
      });*/
      if (item.messageGroupId && item.createUserName !== "system") {
        this.sysMsgId = "";
        // 切换左侧邮件
        if (this.activeId != item.messageGroupId) {
          this.showReply = false;
          this.activeId = item.messageGroupId;
          this.getRightDetail();
        }
      } else {
        this.activeId = "";
        if (this.sysMsgId != item.id) {
          this.sysMsgId = item.id;
          this.getRightDetail();
        }
      }
    },
    handleReply() {
      // 回复
      this.showReply = !this.showReply;
    },
    handleReset() {
      // 重置
      this.formData.createUserName = "";
      this.formData.remindingTitle = "";
      this.formData.customerFavorites = "";
      this.formData.orderOrContainerId = "";
      this.formData.isRead = "";
      this.formData.type = ['staffMessageForward', 'clientMessageForward', 'systemMessageForward'];
      this.dataTime = [];
      this.getMessageList();
    },
    handleSend(refName) {
      // 回复框展开时的发送按钮
      this.$refs[refName].submit();
    },
    handleCancel() {
      // 回复框取消
      this.showReply = false;
      this.$refs.messageFormRef.formReset();
    },
    handleCollect() {
      // 收藏
      this.activeItem.customerFavorites = this.activeItem.customerFavorites == 1 ? 0 : 1;
      this.$http
        .get("cmUser/message2/collect", {
          params: {
            customerFavorites: this.activeItem.customerFavorites,
            messageGroupId: this.activeItem.messageGroupId,
          },
        })
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.messageList.forEach((item) => {
              if (item.messageGroupId === this.activeId) {
                // 更改列表收藏的值
                item.customerFavorites = this.activeItem.customerFavorites;
              }
            });
          }
        })
        .catch(() => {
          this.$message.error(this.$t("prompt.failed"));
        });
    },
    handleCloseDialog() {
      this.messageDialogVisible = false;
      // this.$refs.messageDialogFormRef.formReset();
    },
    toOrderDetail(row) {
      if (row.orderId) {
        this.$http
          .get("/cmUser/message2/orderIsExist", { params: { orderId: row.orderId } })
          .then(({ data: res }) => {
            if (res.code === 200) {
              if (!res.data) {
                this.$message.warning(this.$t("mess.mess80"));
              } else {
                if (row.orderId.indexOf("R") != -1 || row.orderId.indexOf("C") != -1) {
                  //R出现或者C出现
                  this.$router.push({
                    //充值记录
                    name: "rechargeList",
                    query: {
                      rechargeNo: row.orderId,
                    },
                  });
                } else {
                  //订单详情
                  this.$router.push({
                    name: "orderDetail",
                    query: {
                      id: row.orderId,
                      isEdit: "0",
                    },
                  });
                }
              }
            }
          })
          .catch(() => {
            this.$message.warning(this.$t("mess.mess81"));
          });
      } else {
        // 订单列表
        this.$router.push("orderList");
      }
    },
    toFBA() {
      this.$router.push("/fba");
    },
    refreshData() {
      this.handleCancel();
      this.getRightDetail();
      this.getMessageList();
    },
    refreshDialogData() {
      this.handleCloseDialog();
      this.getMessageList();
      this.$refs.messageDialogFormRef.formReset();
    },
    downloadFile(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleCheckBoxChange() {
      this.handleSearch()
    }
  },
};
</script>

<style scoped lang="scss">
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.under-text {
  text-decoration: underline;
  cursor: pointer;
}
.danger-text {
  color: #f56c6c;
}
.primary-text {
  color: #3e8ef7;
}
.flex-div {
  display: flex;
}
.empty-text {
  margin: auto;
  color: #606266;
}
.message-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px - 30px);
  ::v-deep .el-empty {
    width: 30%;
    margin: auto;
    text-align: center;
    color: #606266;
  }
  .message-search {
    background-color: #fff;
    padding: 15px;
    .search-form {
      .search-col {
        display: flex;
      }
      ::v-deep .el-form-item {
        margin-bottom: 0;
        display: flex;
        flex: 1;
      }
      ::v-deep .el-form-item__label {
        flex: none;
      }
      ::v-deep .el-form-item__content {
        flex: 1;
      }
      .max-picker {
        width: auto;
      }
      .form-btn1 {
        min-width: 360px;
        text-align: right;
        margin-right: 0;
      }
    }
  }
  .message-content {
    flex: 1;
    display: flex;
    margin-top: 15px;
    overflow: hidden;
    .message-left-wrap {
      display: flex;
      flex-direction: column;
      width: 35%;
      ::v-deep .el-pagination {
        text-align: left !important;
      }
    }
    .message-content-left {
      margin-right: 15px;
      height: calc(100% - 43px);
      flex: none;
      overflow-y: auto;
      .message-list {
        width: 100%;
        .message-list-item {
          width: 100%;
          background: #fff;
          border-radius: 5px;
          padding: 15px;
          margin-bottom: 15px;
          line-height: 28px;
          border: 1px solid transparent;
          cursor: pointer;
          position: relative;
          .text-cursor {
            cursor: pointer;
          }
          .message-info {
            cursor: pointer;
            display: flex;
            .html-content {
              overflow: hidden;
              height: 28px;
              max-width: 80%;
              ::v-deep img {
                display: none;
              }
            }
          }
          .text-content {
            max-width: 80%;
          }
          .collect-icon {
            position: absolute;
            top: 8px;
            right: 8px;
            color: #595bb3;
            font-size: 24px;
          }
        }
        .active-item {
          border: 1px solid #f59a23;
        }
        .active-sys-item {
          border: 1px solid #f59a23;
        }
      }
    }
    .message-content-right {
      flex: 1;
      background-color: #fff;
      border-radius: 5px;
      padding: 15px;
      position: relative;
      overflow-y: auto;
      .send-message-wrap {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s;
      }
      .reply {
        max-height: 800px;
        transition: max-height 0.5s;
      }
      .send-list-operate {
        position: absolute;
        top: 15px;
        right: 10px;
        display: flex;
      }
      .message-list-item {
        border-bottom: 3px solid #ccc;
        padding-bottom: 20px;
        position: relative;
        .history-detail-form {
          ::v-deep .el-form-item {
            margin-bottom: 0;
          }
        }
        .history-text {
          position: absolute;
          left: 50%;
          bottom: -20px;
          background: #fff;
          transform: translateX(-50%);
          padding: 10px;
        }
        h3 {
          min-height: 19px;
          font-size: 14px;
          margin: 10px 0;
          white-space: pre-wrap;
        }
        .first-title {
          max-width: 65%;
        }
        .send-info {
          display: flex;
          background-color: #fff;
          line-height: 50px;
          gap: 35px;
        }
        .rich-text-content {
          background: #f2f2f2;
          padding: 50px 15px;
          margin: 15px 0;
          ::v-deep img {
            max-width: 100%;
          }
        }
        .association {
          display: flex;
          gap: 35px;
        }
        .annex-list {
          width: 54%;
          .annex-list-item {
            display: flex;
            /*justify-content: space-between;*/
            height: 30px;
            margin-bottom: 10px;
            img{
              width: 50px;
              height: 30px;
              margin-right: 20px;
            }
            .file-name {
              max-width: 70%;
            }
          }
        }
      }
      .history-message-item {
        margin-left: 2em;
        padding: 20px 0;
      }
    }
    .pagination-footer {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      margin-right: 5px;
    }
  }
}
.search-button-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}
.resume-tip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  border: 1px solid #409eff;
  border-radius: 50%;
  color: #409eff;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}
.resume-popover {
  min-height: 80px;
  text-align: left;
}
.resume-info-list {
  max-height: 320px;
  overflow-y: auto;
}
.resume-info-row {
  display: flex;
  line-height: 20px;
  margin-bottom: 8px;
  align-items: flex-start;
}
.resume-info-row:last-child {
  margin-bottom: 0;
}
.resume-info-photo-row {
  align-items: center;
}
.resume-info-intro-row .resume-info-value {
  white-space: pre-wrap;
}
.resume-info-label {
  width: 110px;
  flex: none;
  text-align: right;
  padding-right: 12px;
  color: #909399;
}
.resume-info-value {
  flex: 1;
  word-break: break-all;
  color: #303133;
}
.resume-photo {
  width: 120px;
  max-width: 100%;
  cursor: pointer;
}
</style>
